import PropTypes from 'prop-types';
import React from 'react';

const DOT_COLORS = ['blue', 'red', 'yellow', 'green', 'purple', 'orange'];

const getColorForIndex = (index) => {
  return DOT_COLORS[index % DOT_COLORS.length];
};

const VenueBadges = ({ venueOwnerships, allVenueAccess, maxDisplay = 3 }) => {
  if (allVenueAccess) {
    return <span className="team-venue-all-text">All Venues</span>;
  }

  if (!venueOwnerships || venueOwnerships.length === 0) {
    return <span className="team-venue-all-text">No venues</span>;
  }

  const displayedVenues = venueOwnerships.slice(0, maxDisplay);
  const remainingCount = venueOwnerships.length - maxDisplay;

  return (
    <div className="team-venue-badges">
      {displayedVenues.map((voa, index) => {
        const venueName = voa.venue_ownership?.venueable?.name || voa.venueable?.name || 'Unknown';
        const colorClass = `team-venue-dot team-venue-dot-${getColorForIndex(index)}`;

        return (
          <span key={voa.id || index} className="team-venue-badge">
            <span className={colorClass}></span>
            <span>{venueName}</span>
          </span>
        );
      })}
      {remainingCount > 0 && (
        <span className="team-venue-more-badge">+{remainingCount} more</span>
      )}
    </div>
  );
};

VenueBadges.propTypes = {
  venueOwnerships: PropTypes.array,
  allVenueAccess: PropTypes.bool,
  maxDisplay: PropTypes.number
};

export default VenueBadges;
